"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Float = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const rpdf_renderer_1 = require("@surge-global-engineering/rpdf-renderer");
const clear_float_1 = require("./clear-float");
/**
 * Floats the children to a direction, causing text blocks that appear after the float
 * to wrap around the floated children
 */
const Float = ({ direction, children, }) => {
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx(clear_float_1.ClearFloat, {}, void 0), jsx_runtime_1.jsx(rpdf_renderer_1.View, Object.assign({ hasWrapTextAroundComponent: true }, { children: jsx_runtime_1.jsx(rpdf_renderer_1.View, Object.assign({ style: {
                        position: 'absolute',
                        width: '100%',
                        alignItems: direction === 'right' ? 'flex-end' : 'flex-start',
                    } }, { children: jsx_runtime_1.jsx(rpdf_renderer_1.View, Object.assign({ wrapTextAround: true }, { children: children }), void 0) }), void 0) }), void 0)] }, void 0));
};
exports.Float = Float;
exports.default = exports.Float;
//# sourceMappingURL=float.js.map